import { RootState } from "../slices";
import { useSelector } from 'react-redux';

export const accountStateSelector = (state: RootState) => state.account;
export const useAccountStateSelector = () => useSelector(accountStateSelector);
